
import {ADD_PDF_TO_LIST, REMOVE_PDF_FROM_LIST} from './ReportViewerReducer'

export const pdfMetaData = {
  filename: '',
  pdfType: '',
  isChecked: false,
  isLoading: true,
}

export const addPdfToList = (pdfInfo) => {
  return (dispatch) => {
    dispatch({type: ADD_PDF_TO_LIST, pdfInfo})
  }
}

export const removePdfFromList = (filename, pdfType) => {
  return (dispatch) => {
    dispatch({type: REMOVE_PDF_FROM_LIST, filename, pdfType})
  }
}

export const shouldPopulateEnvelopeReports = ({isEnvelopeComplete, hasReceipt, isReceiptBalanced}) => {
  return isEnvelopeComplete === true && (!hasReceipt || isReceiptBalanced === true)
}